import {PublisherAPIResponse} from './softbox-types.ts';
import { API_URL, DEFAULT_ASPECT, DEFAULT_CKEY, getInitializedMomentFetcher } from '@moment/net/fetch-contstants.ts';
import {PUBLISHER_URL} from '@moment/net/fetch-contstants.ts';
import { PublisherQueryResult } from './softbox-types.ts';
import { resolvedLanguage } from '@/i18n.ts';

export const generatePublisherFetchQuery = (publisher: string) => {return (options: any) => {
    return async (): Promise<PublisherQueryResult> => {
        const momentFetcher = await getInitializedMomentFetcher();
        const logger = options ? options.logger : undefined
        const lang = options ? options.lang : undefined;
        const language = lang || resolvedLanguage('en');
        const url = `${API_URL}/${PUBLISHER_URL}/${publisher}?ckey=${DEFAULT_CKEY}&mp_lang=${language}`;

        const res = await momentFetcher.fetch(url);
        logger?.log(`generatePublisherFetchQuery - hit\n${url}\nstatus=${res.status}`)
        const data:PublisherAPIResponse = await res.json();
        logger?.log(`generatePublisherFetchQuery - data\n${JSON.stringify(data)}`)

        const resInterests = await momentFetcher.fetch(
          `${API_URL}/wp/v1/interests?ckey=${DEFAULT_CKEY}&previewAspect=${DEFAULT_ASPECT}`,
          options
        );
        logger?.log(
          `generatePublisherFetchQuery - hit\n${API_URL}/wp/v1/interests?ckey=${DEFAULT_CKEY}\nstatus=${resInterests.status}`
        );
        const interests = await resInterests.json();

        return {
          news: data,
          interests
        } satisfies PublisherQueryResult;
    };
}};
